























import Vue from 'vue'
import { setLocalStorage } from '@/utils/storage'
import ViewTab from '../../devices-management/viewtab'
import { GatewayServiceProxy } from '@/service-proxies/app-v2/iot-console.service-proxies'

const gsp = new GatewayServiceProxy()

export default Vue.extend({
  name: 'ViewTagModal',
  props: ['id'],
  components: {
    ViewTab
  },
  data() {
    return {
      showViewDialog: false,
      authorization: {}
    }
  },
  methods: {
    async openViewDialog() {
      const data = await gsp.exportGatewayAuthentication(this.id)
      this.authorization = data
      this.showViewDialog = true
    },
    printView() {
      let routeUrl = this.$router.resolve({
        path: '/printDevice'
      })
      setLocalStorage('deviceExport', this.authorization)
      window.open(routeUrl.href, '_blank')
    },
    downloadView() {
      const data = this.authorization.aesFile
      const name = this.authorization.name
      const urlObject = window.URL || (window as any)
      const export_blob = new Blob([data])
      const save_link = document.createElementNS(
        'http://www.w3.org/1999/xhtml',
        'a'
      ) as any
      save_link.href = urlObject.createObjectURL(export_blob)
      save_link.download = `${this.authorization.sn || 'sn'}.txt`
      const ev = document.createEvent('MouseEvents')
      ev.initMouseEvent(
        'click',
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      )
      save_link.dispatchEvent(ev)
    }
  }
})
